module.exports = __webpack_public_path__ + "static/media/btn-podcast-red.c7ef43bf.svg";